import { render, staticRenderFns } from "./ScreenBill.vue?vue&type=template&id=31f67ef6&scoped=true"
import script from "./ScreenBill.vue?vue&type=script&lang=js"
export * from "./ScreenBill.vue?vue&type=script&lang=js"
import style0 from "./ScreenBill.vue?vue&type=style&index=0&id=31f67ef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f67ef6",
  null
  
)

export default component.exports